import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
   state: {
      'cloud_datasets':[],
      'services': [],
      'service_terms': [],
      'umm_s': [],
      'capabilities': {},
      'capabilities_ready': false,
      //'umm_var': [],
      'umm_var_api': '',
      'umm_t_api': '',
      'umm_g_api': '',
      'umm_s_items': [],
      'umm_t_items': [],
      'item_counts': 0,
      'page_size': 10,
      'page_total': 1,
      'basePath': '',
      'display_mode': 'list',
      'load_item_count': 10,
      'filtered_item_count': 0,
      'selected_services':[],
      'services_tools': {},
      'science_keyword_modal_data': {'datasets':[],'measurements':undefined},
      'query_params': [],
      'data_ready': false,
      'sort_by': {'field':'','sort_dir':''},
      'modal': {
         'science_keyword_datasets': {'visible':false},
         'tools_services': {'visible':false}
      }
   },
   mutations: {
      SET_DATA: function(state, data) {
         //console.log(data);
         if(data.data != undefined) state.cloud_datasets = data.data;
         if(data.base_path != undefined) state.basePath = data.base_path;
         //state.umm_s = data.umm_s.data;
         //state.umm_var = data.umm_var.data;
         state.capabilities = data.capabilities
         //console.log(data.capabilities);
         state.umm_var_api = data.umm_var_api;
         state.umm_g_api = data.umm_g_api;
         state.item_counts = data.datasets_parameters.size;
         state.page_size = data.datasets_parameters.page_size;
         state.query_params = data.datasets_parameters.parameters;
         state.page_total = data.datasets_parameters.page_total;

         // if(data.data) {
         //    state.cloud_datasets = data.data;
         // }
         if(data.paging_data) {
            data.paging_data.forEach(element => {
               // Vue.axios.get(state.umm_g_api + ".json?concept-id=" + element['meta']['concept-id'] + "&page_size=1&sort_key[]=-end_date").then((response)=> {               
               //    if(response['data']['feed']['entry'][0] != undefined && response['data']['feed']['entry'][0]['time_end'] != undefined && element['umm']['AdditionalAttributes'] != undefined) {                  
               //       element['umm']['AdditionalAttributes'].push({
               //          'Name':'latest_granule_ummg_end_time',
               //          'Value':response['data']['feed']['entry'][0]['time_end']["time_end"]
               //       });
               //       //console.log(element['umm']['AdditionalAttributes']);
               //    }
               //    return element;
               // }).then((response) => {
               //    state.cloud_datasets.push(response);
               // });
               state.cloud_datasets.push(element);
            });
         }
      },
      SET_DISPLAY_MODE: function(state, mode) {
         state.display_mode = mode;
      },
      SET_FILTERED_ITEM_COUNT: function(state, count) {
         state.filtered_item_count = count;
      },
      SET_DISPLAY_ITEM_COUNT: function(state, count) {
         state.load_item_count += count;
      },
      UPDATE_CAPABILITIES: function(state, capabilities_data) {
         let capability_tools_services = [];
         let dataset_tools_services = [];
         state.cloud_datasets.forEach(function(dataset) {
            Vue._.forOwn(capabilities_data, function(capability, key) {
               capability_tools_services = [];
               dataset_tools_services = [];
               //console.log(dataset);
               if(Array.isArray(capability.tools_services)) {
                  capability.tools_services.forEach(function(item) {
                     capability_tools_services.push(item['concept-id']);
                  });                  
                  if(dataset['meta']['associations'] && dataset['meta']['associations']['services']) dataset_tools_services = dataset_tools_services.concat(dataset['meta']['associations']['services']);
                  if(dataset['meta']['associations'] && dataset['meta']['associations']['tools']) dataset_tools_services = dataset_tools_services.concat(dataset['meta']['associations']['tools']);

                  const intersect = Vue._.intersection(capability_tools_services, dataset_tools_services);
                  if(intersect.length > 0) capabilities_data[key].count += 1;
               }
            });
         });

         state.capabilities = capabilities_data;
         state.capabilities_ready = true;
      },
      RESET_CAPABILITIES_COUNT: function(state) {
         Vue._.forOwn(state.capabilities, function(capability, key) {
            state.capabilities[key].count = 0;
         });
      },
      INCREMENT_CAPABILITY_COUNT: function(state, key) {
         state.capabilities[key].count += 1;
      },
      UPDATE_SELECTED_SERVICES: function(state, service) {
         //console.log(service);
         if(!state.selected_services.includes(service)) {
            state.selected_services.push(service);
         } else {
            state.selected_services = state.selected_services.filter(selected_service => (selected_service !== service));
         }
         //console.log(state.selected_services);
         // Vue._.forOwn(state.capabilities, function(capability, key) {
         //    state.capabilities[key].count = 0;
         // });
      },
      RESET_SELECTED_SERVICES: function(state) {
         state.selected_services = [];
         // Vue._.forOwn(state.capabilities, function(capability, key) {
         //    state.capabilities[key].count = 0;
         // });
      },
      // SET_MODAL_SCIENCE_KEYWORD: function(state, keywords) {
      //    state.modal_science_keyword['keyword'] = keywords['keyword'];
      //    state.modal_science_keyword['scienceKeywords'] = keywords['scienceKeywords'];
      // },
      SET_SERVICES_TOOLS: function(state, services_tools) {
         state.services_tools = services_tools;
      },
      SET_SCIENCE_KEYWORD_MODAL_DATA: function(state, datasets) {
         state.science_keyword_modal_data = datasets;
      },
      SET_UMM_S_DATA: function(state, umms) {
         state.umm_s = umms;
      },
      SET_DATASETS: function(state, new_datasets) {
         // console.log('set datasets');
         let index = 0;
         new_datasets.forEach(element => {
            index++;
            state.cloud_datasets.push(element);            
         });
      },
      SET_APPEND_DATASETS: function(state, new_datasets) {
         new_datasets.forEach(element => {
            // if(element['meta']['associations']['tools'] != undefined && element['meta']['associations']['tools'].includes('TL2092786348-POCLOUD')) {
            //    console.log(element);
            // }
            //console.log(state.umm_g_api);
            //console.log(state.umm_g_api + ".json?concept-id=" + element['meta']['concept-id'] + "&page_size=1&sort_key[]=-end_date");
            
            // Vue.axios.get(state.umm_g_api + ".json?concept-id=" + element['meta']['concept-id'] + "&page_size=1&sort_key[]=-end_date").then((response)=> {               
            //    if(response['data']['feed']['entry'][0] != undefined && response['data']['feed']['entry'][0]['time_end'] != undefined && element['umm']['AdditionalAttributes'] != undefined) {                  
            //       element['umm']['AdditionalAttributes'].push({
            //          'Name':'latest_granule_ummg_end_time',
            //          'Value':response['data']['feed']['entry'][0]['time_end']["time_end"]
            //       });
            //    }
            //    return element;
            // }).then((response) => {
            //    state.cloud_datasets.push(response);
            // });
                         
            state.cloud_datasets.push(element);
            
            //state.cloud_datasets.push(element);
         });
      },
      SET_APPEND_DATASET: function(state, new_dataset) {
         state.cloud_datasets.push(new_dataset);
      },
      SET_DATA_READY: function(state, is_ready) {
         // while (state.item_counts != state.filtered_item_count) {
         //    console.log(state.item_counts);
         //    console.log(state.filtered_item_count);            
         //    //wait
         // }
         state.data_ready = is_ready;
      },
      SET_UMM_S_T_ITEMS: function(state, umm_data) {
         state.umm_s_items = umm_data['umms'];
         state.umm_t_items = umm_data['ummt'];
      },
      SET_MODAL_VISIBILITY: function(state, modal_visibility) {
         state.modal[modal_visibility.modal_name].visible = modal_visibility.visibility;
      },
      SET_SORT_BY: function(state, sort_field) {
         //console.log(state.sort_by);
         const current_field = state.sort_by['field'];
         state.sort_by['field'] = sort_field;
         if(state.sort_by['field'] == current_field) {
            //state.sort_by['sort_dir'] = (state.sort_by['sort_dir'] == '') ? 'asc' : (state.sort_by['sort_dir'] == 'asc') ? 'desc' : 'asc';
            state.sort_by['sort_dir'] = (state.sort_by['sort_dir'] != 'asc') ? 'asc' : 'desc';
         } else if(state.sort_by['field'] != current_field && state.sort_by['field'] == 'start'){
            state.sort_by['sort_dir'] = 'desc';
         } else {
            state.sort_by['sort_dir'] = 'asc';
         }
         //state.sort_by['sort_dir'] = (state.sort_by['sort_dir'] == '') ? 'asc' : (state.sort_by['sort_dir'] == 'asc') ? 'desc' : 'asc';
         //console.log(state.sort_by);
      }
   }
});